import React, { useState, useEffect, useRef, useCallback } from "react";
import "./CustomAnchor.css";

const CustomAnchor = ({ items, currentSelection, setCurrentSelection, onChange, breakpoint = 960 }) => {
  const linkRefs = useRef({});
  const [sliderStyle, setSliderStyle] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  const updateSliderPosition = useCallback(() => {
    const activeLink = linkRefs.current[currentSelection];
    if (!activeLink) {
      setSliderStyle({ opacity: 0 });
      return;
    }

    const parentContainer = activeLink.closest(".custom-anchor");
    if (!parentContainer) return;

    const activeRect = activeLink.getBoundingClientRect();
    const containerRect = parentContainer.getBoundingClientRect();

    if (!isMobile) {
      const totalHeight = activeLink.offsetHeight;
      const sliderHeight = totalHeight - 10;
      const topOffset = activeRect.top - containerRect.top + (totalHeight - sliderHeight) / 2;

      setSliderStyle({
        top: `${topOffset}px`,
        height: `${sliderHeight}px`,
        width: "3px",
        left: "0",
        opacity: 1,
      });
    } else {
      const totalWidth = activeLink.offsetWidth;
      const sliderWidth = totalWidth - 10;
      const leftOffset = activeRect.left - containerRect.left + (totalWidth - sliderWidth) / 2;

      setSliderStyle({
        left: `${leftOffset}px`,
        width: `${sliderWidth}px`,
        height: "3px",
        top: "auto",
        bottom: "0",
        opacity: 1,
      });
    }
  }, [currentSelection, isMobile]);

  const handleClick = (href) => {
    // if (onChange) onChange(href);

    // const targetElement = document.querySelector(href);
    // if (targetElement) {
    //   targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    // }
    onChange(href);
  };

  // const handleKeyPress = (e, href) => {
  //   if (e.key === "Enter" || e.key === " ") {
  //     handleClick(href);
  //   }
  // };

  useEffect(() => {
    if (currentSelection) {
      updateSliderPosition();
    } else {
      setSliderStyle({ opacity: 0 });
    }
  }, [currentSelection, items, updateSliderPosition, isMobile]);

  useEffect(() => {
    const handleResize = () => {
      if (currentSelection) {
        updateSliderPosition();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [currentSelection, updateSliderPosition]);

  return (
    <div className={`custom-anchor ${isMobile ? "mobile" : ""}`}>
      <div className="custom-anchor-slider" style={sliderStyle}></div>

      {items.map(({ key, href, title }) => (
        <div
          key={key}
          role="button"
          tabIndex={0}
          className={`custom-anchor-link ${currentSelection === href ? "active" : ""}`}
          onClick={() => handleClick(href)}
          // onKeyPress={(e) => handleKeyPress(e, href)}
          ref={(el) => (linkRefs.current[href] = el)}
        >
          <span className="custom-anchor-link-title">{title}</span>
        </div>
      ))}
    </div>
  );
};

export default CustomAnchor;